/* eslint-disable no-plusplus */
/* eslint-disable no-console */
/* eslint-disable react/prop-types */

import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import Fab from '@mui/material/Fab';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
//import { useRecoilValue } from 'recoil';
import { useRecoilValue, useRecoilState } from 'recoil';
import Slide from '@mui/material/Slide';
import Navbar from './Navbar';
import ProjectDetails from './ProjectDetails';
import SidebarBox from './SidebarBox';
import ConfirmExitDialog from './ConfirmExitDialog';
import {
  openProjectNameAtom,
  projectsDataAtom,
  mobileAtom,
  openConfirmExitAtom,
  openSaveChangesDialogAtom,
} from '../Atoms';
import InfoSidebar from './InfoSidebar';
import SaveChangesDialog from './SaveChangesDialog';

const Transition = React.forwardRef(function Transition(props, ref) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Slide direction="up" ref={ref} {...props} />;
});

const ProjectPage = function ProjectPage({ close }) {
  const [currentProjectData, setCurrentProjectData] = useState([]);
  const projectsData = useRecoilValue(projectsDataAtom);
  const [openProjectName, setOpenProjectName] = useRecoilState(openProjectNameAtom);
  const [openConfirmExit, setOpenConfirmExit] = useRecoilState(openConfirmExitAtom);
  const [openSaveChangesDialog, setOpenSaveChangesDialog] = useRecoilState(openSaveChangesDialogAtom);
  const mobile = useRecoilValue(mobileAtom);
  const [openInfoSide, setOpenInfoSide] = useState(false);
  useEffect(() => {
    setCurrentProjectData(projectsData.find((x) => x.Name === openProjectName && x.isCurrent === 1));
  }, [projectsData]);

  const sidebar = <InfoSidebar />;
  return (
    <Dialog
      fullScreen
      open
      sx={{
        '.MuiDialog-paper': {
          backgroundColor: '#ece7e7',
          minWidth: '350px',
        },
      }}
      onClose={() => setOpenProjectName(null)}
      TransitionComponent={Transition}
    >
      <Navbar title={openProjectName} show setSidebar={() => setOpenInfoSide(!openInfoSide)} />
      {!mobile ? (
        <Grid container style={{ width: '100vw' }}>
          <div style={{ maxWidth: '280px', minWidth: '280px' }}>
            <SidebarBox widget={sidebar} openSidebar={openInfoSide} />
          </div>
          <div
            style={{
              width: 'calc(100% - 280px)',
              overflow: 'auto',
            }}
          >
            <ProjectDetails idVersione={currentProjectData?.idVersione} />
          </div>
        </Grid>
      ) : (
        <Grid container style={{ width: '100vw' }}>
          <div style={{ width: '100%', paddingRight: '8px', paddingLeft: '8px' }}>
            <SidebarBox widget={sidebar} openSidebar={openInfoSide} />
          </div>
          <div style={{ width: '100%', paddingRight: '4px' }}>
            <ProjectDetails idVersione={currentProjectData?.idVersione} />
          </div>
        </Grid>
      )}
      {mobile && (
        <Fab
          size="small"
          color="p-green"
          aria-label="add"
          onClick={close}
          sx={{ bottom: '10px', left: '8px', zIndex: 1200, position: 'fixed' }}
        >
          <ArrowBackIcon color="white" />
        </Fab>
      )}
      <SaveChangesDialog open={openSaveChangesDialog} close={() => setOpenSaveChangesDialog(false)} />
      <ConfirmExitDialog open={openConfirmExit} close={() => setOpenConfirmExit(false)} />
    </Dialog>
  );
};

export default ProjectPage;
